/* eslint-disable */ 
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as pdfMake from 'pdfmake';
import pdfFonts from "pdfmake/build/vfs_fonts";
// import * as moment from 'moment';
import moment from 'moment';
import XlsxPopulate from "xlsx-populate";
import { AppHelper } from '../../helpers/AppHelper';

const customNameForWFH = {	
  placeId: "Project ID",	
  cam_name: "Agent",	
  place_name: "Project",	
  camId: "Cam ID",	
  priority: "Priority",	
  priorityReported: "Reported Priority",	
  name: "Violation",	
  event_time: "Event Date Time",	
  type: "Violation Type",	
  grouped_events: "Grouped Events",	
  image: "Image",	
  comments: "Comments",	
}
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
var wscols = [
  { wch: 3 },
  { wpx: 100 },
  { wpx: 150 },
  { wpx: 100 },
  { wpx: 350 },
  { wpx: 250 }
];
var wsrows = [{}]
export class FileDownloader {
  constructor() { }

  // static exportAsExcelFile(json, excelFileName, pword, call) {
  //   let worksheet = XLSX.utils.json_to_sheet(json);
  //   if (excelFileName == "audit") {
  //     worksheet['!cols'] = wscols;
  //     for (let index = 0; index < json.length; index++) {
  //       let element = json[index];
  //       wsrows.push(
  //         { hpx: 110 }
  //       )
  //     }
  //     worksheet['!rows'] = wsrows;
  //   }

  //   let workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
  //   let excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  //   XlsxPopulate.fromDataAsync(excelBuffer)
  //     .then(function (workbook) {
  //       workbook.outputAsync({ type: "arraybuffer", password: pword })
  //         .then(function (data) {
  //           FileDownloader.saveAsExcelFile(data, excelFileName);
  //           if(call) {
  //             call()
  //           }
  //         });
  //     }).catch((err) => {
  //       console.log("error", err)
  //     });
  // }

  static exportAsCsvFile(metaData, jsonData, csvFileName, pword, call) {
    const convertToCsv = (arr) => {
      const headers = Object.keys(arr[0]);
      const rows = arr.map(obj =>
        headers.map(header => {
          const value = obj[header] !== undefined ? obj[header] : '';
          const escapedValue = String(value).replace(/"/g, '""');
          return /[",\n]/.test(escapedValue) ? `"${escapedValue}"` : escapedValue;
        }).join(',')
      );
      return [headers.join(','), ...rows].join('\n');
    };

    // const csvContent = convertToCsv(jsonData);

    // const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    const csvContent = '\ufeff' + convertToCsv(jsonData);
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', csvFileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } else {
      console.error('Download attribute not supported in this browser.');
    }

    if (call) {
      call();
    }
  }

  static exportAsExcelFile2(metaData, jsonData, excelFileName, pword, call) {
    // Create a new workbook and add a worksheet
    let workbook = XLSX.utils.book_new();
    let worksheet = XLSX.utils.aoa_to_sheet([[]]); // Start with an empty sheet

    // Append meta data to the worksheet
    XLSX.utils.sheet_add_aoa(worksheet, metaData, { origin: 'A1' });

    // Calculate the starting row for the main data table (meta data length + 2 for a blank row)
    const dataStartRow = metaData.length + 2;

    // Append main data to the worksheet
    XLSX.utils.sheet_add_json(worksheet, jsonData, { origin: `A${dataStartRow}` });

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Write the workbook to a buffer
    let excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Use XlsxPopulate to apply styles and password protection
    XlsxPopulate.fromDataAsync(excelBuffer)
      .then(function (workbook) {
        // Apply bold styling to the meta table titles
        for (let i = 1; i <= metaData.length; i++) {
          workbook.sheet(0).cell(`A${i}`).style("bold", true);
        }
        // const mainDataRowCount = jsonData.length;
        // for (let i = dataStartRow; i < dataStartRow + mainDataRowCount; i++) {
        //   workbook.sheet(0).row(i).height(20); // Adjust the height value as needed
        // }
  
        // Output the workbook with password protection
        return workbook.outputAsync({ type: "arraybuffer", password: pword });
      })
      .then(function (data) {
        FileDownloader.saveAsExcelFile(data, excelFileName);
        if (call) {
          call();
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  }

  static exportAsExcelFile(metaData, jsonData, excelFileName, pword, call) {
    // Create a new workbook and add a worksheet
    let workbook = XLSX.utils.book_new();
    let worksheet = XLSX.utils.aoa_to_sheet([[]]); // Start with an empty sheet
  
    // Append meta data to the worksheet
    XLSX.utils.sheet_add_aoa(worksheet, metaData, { origin: 'A1' });
  
    // Calculate the starting row for the main data table (meta data length + 2 for a blank row)
    const dataStartRow = metaData.length + 2;
  
    // Append main data to the worksheet
    XLSX.utils.sheet_add_json(worksheet, jsonData, { origin: `A${dataStartRow}` });
  
    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  
    // Write the workbook to a buffer
    let excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  
    // Use XlsxPopulate to apply styles and password protection
    XlsxPopulate.fromDataAsync(excelBuffer)
      .then(function (workbook) {
        const sheet = workbook.sheet(0);
        
        // Apply styling to the metadata table
        if (metaData.length >= 1) {
          const numColumns = metaData[0].length;
          
          // Add borders and styling to each cell in the metadata table
          for (let row = 1; row <= metaData.length; row++) {
            for (let col = 1; col <= numColumns; col++) {
              const cell = sheet.cell(row, col);
              
              // Apply borders to all cells
              cell.style("border", {
                top: { style: "thin" },
                right: { style: "thin" },
                bottom: { style: "thin" },
                left: { style: "thin" }
              });
              
              // Make header row bold with background color
              if (row === 1) {
                cell.style({
                  bold: true,
                  fill: { type: "solid", color: "F2F2F2" } // Light gray background
                });
              }
            }
          }
        }
  
        // Output the workbook with password protection
        return workbook.outputAsync({ type: "arraybuffer", password: pword });
      })
      .then(function (data) {
        FileDownloader.saveAsExcelFile(data, excelFileName);
        if (call) {
          call();
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  }

  static saveAsExcelFile(buffer, fileName) {
    const data = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }

  // static downloadAsPdf(columns, rows, fileName, columnStyles, pword, type, call, meta) {
  //   const col = []
  //   const widths = new Array(Object.keys(columns).length - 1).fill(0);
  //   var count = 0;
  //   var headerKeys = []
  //   var totalWidth = 100;
  //   var indexOfCommetns
  //   var indexOfPriority
  //   Object.keys(columns).forEach(k => {
  //     var obj = {}
  //     obj.style = 'header'
  //     obj.text = type && type == "wfhTeams" && columns[k].customTitle ? columns[k].customTitle : columns[k].title
  //     headerKeys.push(obj.text)
  //     col.push(obj)
  //   })

	// // if (meta) {
  //   //     var metaContent = [];
  //   //     Object.keys(meta).forEach(k => {
  //   //         metaContent.push([
  //   //             { text: `${k}: ${meta[k]}`, style: 'metaStyle' }
  //   //         ]);
  //   //     });

  //   //     // Insert the metaContent as rows above the table
  //   //     rows.unshift(...metaContent); // Add meta information above the table
  //   // }



  //   totalWidth -= 4;
  //   headerKeys.splice(headerKeys.indexOf("SL No."), 1, undefined)
  //   widths.unshift(4 + "%")
  //   count++;
  //   if (headerKeys.includes("comments")) {
  //     indexOfCommetns = headerKeys.indexOf('comments')
  //     headerKeys.splice(indexOfCommetns, 1, undefined)
  //     totalWidth -= 35;
  //     count++;
  //   }
  //   if (headerKeys.includes("priority")) {
  //     indexOfPriority = headerKeys.indexOf('priority')
  //     headerKeys.splice(indexOfPriority, 1, undefined)
  //     totalWidth -= 8;
  //     count++;
  //   }
  //   for (let index = 0; index < headerKeys.length; index++) {
  //     var element = headerKeys[index]
  //     if (element) {
  //       widths.splice(headerKeys.indexOf(element), 1, ((totalWidth / (columns.length - count)) + "%"))
  //     }
  //   }
  //   if (indexOfCommetns || indexOfCommetns == 0) {
  //     widths.splice(indexOfCommetns, 1, 35 + "%")
  //   }
  //   if (indexOfPriority || indexOfPriority == 0) {
  //     widths.splice(indexOfPriority, 1, 8 + "%")
  //   }
  //   rows.unshift(col)
  //   var docDefinition = {
  //     userPassword: pword,
  //     permissions: {
  //       printing: 'highResolution', //'lowResolution'
  //       modifying: false,
  //       copying: true,
  //       annotating: true,
  //       fillingForms: true,
  //       contentAccessibility: true,
  //       documentAssembly: true
  //     },
  //     content: [
  //       {
  //         layout: 'headerLineOnly',
  //         table: {
  //           widths: widths,
  //           headerRows: 1,
  //           body: rows
  //         }
  //       }
  //     ],
  //     styles: {
  //       header: {
  //         fontSize: 8,
  //         bold: true,
  //         fillColor: "#0082be",
  //         color: "white"
  //       },
  //     metaStyle: {
  //       fontSize: 8,
  //       bold: true,
  //       color: "#000",
  //       margin: [0, 5]
  //     }
  //     },
  //     defaultStyle: {
  //       fontSize: 6,
  //     }
  //   };
  //   pdfMake.createPdf(docDefinition).download(fileName, (err, res) => {
  //     if (call) {
  //       call()
  //     }

  //   });

  // }

  // static downloadAsPdf2(columns, rows, fileName, columnStyles, pword, type, call, metaTable, chart) {
  //   const col = [];
  //   const widths = new Array(Object.keys(columns).length - 1).fill(0);
  //   let count = 0;
  //   const headerKeys = [];
  //   let totalWidth = 100;
  //   let indexOfComments;
  //   let indexOfPriority;
  
  //   Object.keys(columns).forEach(k => {
  //     const obj = {
  //       style: 'header',
  //       text: type === "wfhTeams" && columns[k].customTitle ? columns[k].customTitle : columns[k].title
  //     };
  //     headerKeys.push(obj.text);
  //     col.push(obj);
  //   });
  
  //   totalWidth -= 4;
  //   headerKeys.splice(headerKeys.indexOf("SL No."), 1, undefined);
  //   widths.unshift("4%");
  //   count++;
  
  //   if (headerKeys.includes("comments")) {
  //     indexOfComments = headerKeys.indexOf('comments');
  //     headerKeys.splice(indexOfComments, 1, undefined);
  //     totalWidth -= 35;
  //     count++;
  //   }
  
  //   if (headerKeys.includes("priority")) {
  //     indexOfPriority = headerKeys.indexOf('priority');
  //     headerKeys.splice(indexOfPriority, 1, undefined);
  //     totalWidth -= 8;
  //     count++;
  //   }
  
  //   for (let index = 0; index < headerKeys.length; index++) {
  //     const element = headerKeys[index];
  //     if (element) {
  //       widths.splice(headerKeys.indexOf(element), 1, `${totalWidth / (columns.length - count)}%`);
  //     }
  //   }
  
  //   if (indexOfComments !== undefined) {
  //     widths.splice(indexOfComments, 1, "35%");
  //   }
  
  //   if (indexOfPriority !== undefined) {
  //     widths.splice(indexOfPriority, 1, "8%");
  //   }
  
  //   rows.unshift(col);
  
  //   let metaTableContent = [];
  //   let chartContent = [
  //     {
  //      image:chart
  //   }
  //   ]

  //   if (metaTable && metaTable.length >= 2) {
  //     const metaHeaders = metaTable[0];
  //     const metaValues = metaTable[1];
      
  //     const metaColumnCount = metaHeaders.length;
  //     const metaColumnWidths = Array(metaColumnCount).fill(`${100/metaColumnCount}%`);
      
  //     const metaHeaderRow = metaHeaders.map(header => ({
  //       text: header,
  //       style: 'metaHeader'
  //     }));
      
  //     const metaValueRow = metaValues.map(value => ({
  //       text: String(value),
  //       style: 'metaValue'
  //     }));
      
  //     metaTableContent = [
  //       {
  //         margin: [0, 0, 0, 10],
  //         table: {
  //           widths: metaColumnWidths,
  //           headerRows: 1,
  //           body: [metaHeaderRow, metaValueRow]
  //         },
  //         layout: {
  //           hLineWidth: function(i, node) { return 1; },
  //           vLineWidth: function(i, node) { return 1; },
  //           hLineColor: function(i, node) { return '#aaa'; },
  //           vLineColor: function(i, node) { return '#aaa'; },
  //           paddingLeft: function(i) { return 4; },
  //           paddingRight: function(i) { return 4; },
  //           paddingTop: function(i) { return 2; },
  //           paddingBottom: function(i) { return 2; }
  //         }
  //       }
  //     ];

  //   }

  //   const docDefinition = {
  //     userPassword: pword,
  //     permissions: {
  //       printing: 'highResolution',
  //       modifying: false,
  //       copying: true,
  //       annotating: true,
  //       fillingForms: true,
  //       contentAccessibility: true,
  //       documentAssembly: true
  //     },
  //     content: rows.length > 0 ? [
  //       ...chartContent,
  //       ...metaTableContent,
  //       {
  //         layout: 'headerLineOnly',
  //         table: {
  //           widths: rows.length > 0 ? widths : [],
  //           headerRows:  rows.length > 0 ? 1 : 0,
  //           body: rows.length > 0 ? rows : []
  //         }
  //       }
  //     ]:[],
  //     styles: {
  //       header: {
  //         fontSize: 8,
  //         bold: true,
  //         fillColor: "#0082be",
  //         color: "white"
  //       },
  //       metaHeader: {
  //         fontSize: 8,
  //         bold: true,
  //         fillColor: "#e8e8e8",
  //         color: "#333333"
  //       },
  //       metaValue: {
  //         fontSize: 7,
  //         color: "#000"
  //       }
  //     },
  //     defaultStyle: {
  //       fontSize: 6,
  //     }
  //   };
  
  //   pdfMake.createPdf(docDefinition).download(fileName, (err, res) => {
  //     if (call) {
  //       call();
  //     }
  //   });
  // }

  // static downloadAsPdf(columns, rows, fileName, columnStyles, pword, type, call, metaTable, chart, logo) {
  //   // Initialize arrays and variables
  //   const col = [];
  //   const widths = new Array(Object.keys(columns).length - 1).fill(0);
  //   let count = 0;
  //   const headerKeys = [];
  //   let totalWidth = 100;
  //   let indexOfComments;
  //   let indexOfPriority;
  
  //   // Only process columns and create headers if rows exist
  //   if (rows.length > 0) {
  //     Object.keys(columns).forEach(k => {
  //       const obj = {
  //         style: 'header',
  //         text: type === "wfhTeams" && columns[k].customTitle ? columns[k].customTitle : columns[k].title
  //       };
  //       headerKeys.push(obj.text);
  //       col.push(obj);
  //     });
  
  //     totalWidth -= 4;
  //     headerKeys.splice(headerKeys.indexOf("SL No."), 1, undefined);
  //     widths.unshift("4%");
  //     count++;
  
  //     if (headerKeys.includes("comments")) {
  //       indexOfComments = headerKeys.indexOf('comments');
  //       headerKeys.splice(indexOfComments, 1, undefined);
  //       totalWidth -= 35;
  //       count++;
  //     }
  
  //     if (headerKeys.includes("priority")) {
  //       indexOfPriority = headerKeys.indexOf('priority');
  //       headerKeys.splice(indexOfPriority, 1, undefined);
  //       totalWidth -= 8;
  //       count++;
  //     }
  
  //     for (let index = 0; index < headerKeys.length; index++) {
  //       const element = headerKeys[index];
  //       if (element) {
  //         widths.splice(headerKeys.indexOf(element), 1, `${totalWidth / (columns.length - count)}%`);
  //       }
  //     }
  
  //     if (indexOfComments !== undefined) {
  //       widths.splice(indexOfComments, 1, "35%");
  //     }
  
  //     if (indexOfPriority !== undefined) {
  //       widths.splice(indexOfPriority, 1, "8%");
  //     }
  
  //     // Add column headers only if we have rows
  //     rows.unshift(col);
  //   }
  
  //   // Prepare meta table content
  //   let metaTableContent = [];
    
  //   let chartContent = chart ? [
  //     {
  //       image: chart,
  //       alignment: 'center',
  //       width: 500, 
  //       // margin: [0, 0, 0, 10]
  //     }
  //   ] : [];

  //   let logoContent = logo ? [
  //     {
  //       image: logo,
  //       alignment: 'right',
  //       width: 200, 
  //       // margin: [0, 0, 0, 0]
  //     }
  //   ] : [];
  
  //   if (metaTable && metaTable.length >= 2) {
  //     const metaHeaders = metaTable[0];
  //     const metaValues = metaTable[1];
      
  //     const metaColumnCount = metaHeaders.length;
  //     const metaColumnWidths = Array(metaColumnCount).fill(`${100/metaColumnCount}%`);
      
  //     const metaHeaderRow = metaHeaders.map(header => ({
  //       text: header,
  //       style: 'metaHeader'
  //     }));
      
  //     const metaValueRow = metaValues.map(value => ({
  //       text: String(value),
  //       style: 'metaValue'
  //     }));
      
  //     metaTableContent = [
  //       {
  //         margin: [0, 0, 0, 10],
  //         table: {
  //           widths: metaColumnWidths,
  //           headerRows: 1,
  //           body: [metaHeaderRow, metaValueRow]
  //         },
  //         layout: {
  //           hLineWidth: function(i, node) { return 1; },
  //           vLineWidth: function(i, node) { return 1; },
  //           hLineColor: function(i, node) { return '#aaa'; },
  //           vLineColor: function(i, node) { return '#aaa'; },
  //           paddingLeft: function(i) { return 4; },
  //           paddingRight: function(i) { return 4; },
  //           paddingTop: function(i) { return 2; },
  //           paddingBottom: function(i) { return 2; }
  //         }
  //       }
  //     ];
  //   }
  
  //   // Define table content only if rows exist
  //   let tableContent = [];
  //   if (rows.length > 0) {
  //     tableContent = [
  //       {
  //         layout: 'headerLineOnly',
  //         table: {
  //           widths: widths,
  //           headerRows: 1,
  //           body: rows
  //         }
  //       }
  //     ];
  //   }
  
  //   const docDefinition = {
  //     userPassword: pword,
  //     permissions: {
  //       printing: 'highResolution',
  //       modifying: false,
  //       copying: true,
  //       annotating: true,
  //       fillingForms: true,
  //       contentAccessibility: true,
  //       documentAssembly: true
  //     },
  //     content: [
  //       ...logoContent,
  //       ...metaTableContent,
  //       ...chartContent,
  //       ...tableContent
  //     ],
  //     styles: {
  //       header: {
  //         fontSize: 8,
  //         bold: true,
  //         fillColor: "#0082be",
  //         color: "white"
  //       },
  //       metaHeader: {
  //         fontSize: 8,
  //         bold: true,
  //         fillColor: "#e8e8e8",
  //         color: "#333333"
  //       },
  //       metaValue: {
  //         fontSize: 7,
  //         color: "#000"
  //       }
  //     },
  //     defaultStyle: {
  //       fontSize: 6,
  //     }
  //   };
  
  //   pdfMake.createPdf(docDefinition).download(fileName, (err, res) => {
  //     if (call) {
  //       call();
  //     }
  //   });
  // }

  // static downloadAsPdf22(columns, rows, fileName, columnStyles, pword, type, call, metaTable, chart, logo) {
  //   // Initialize arrays and variables
  //   const col = [];
  //   const widths = new Array(Object.keys(columns).length - 1).fill(0);
  //   let count = 0;
  //   const headerKeys = [];
  //   let totalWidth = 100;
  //   let indexOfComments;
  //   let indexOfPriority;
  
  //   // Only process columns and create headers if rows exist
  //   if (rows.length > 0) {
  //     Object.keys(columns).forEach(k => {
  //       const obj = {
  //         style: 'header',
  //         text: type === "wfhTeams" && columns[k].customTitle ? columns[k].customTitle : columns[k].title
  //       };
  //       headerKeys.push(obj.text);
  //       col.push(obj);
  //     });
  
  //     totalWidth -= 4;
  //     headerKeys.splice(headerKeys.indexOf("SL No."), 1, undefined);
  //     widths.unshift("4%");
  //     count++;
  
  //     if (headerKeys.includes("comments")) {
  //       indexOfComments = headerKeys.indexOf('comments');
  //       headerKeys.splice(indexOfComments, 1, undefined);
  //       totalWidth -= 35;
  //       count++;
  //     }
  
  //     if (headerKeys.includes("priority")) {
  //       indexOfPriority = headerKeys.indexOf('priority');
  //       headerKeys.splice(indexOfPriority, 1, undefined);
  //       totalWidth -= 8;
  //       count++;
  //     }
  
  //     for (let index = 0; index < headerKeys.length; index++) {
  //       const element = headerKeys[index];
  //       if (element) {
  //         widths.splice(headerKeys.indexOf(element), 1, `${totalWidth / (columns.length - count)}%`);
  //       }
  //     }
  
  //     if (indexOfComments !== undefined) {
  //       widths.splice(indexOfComments, 1, "35%");
  //     }
  
  //     if (indexOfPriority !== undefined) {
  //       widths.splice(indexOfPriority, 1, "8%");
  //     }
  
  //     // Add column headers only if we have rows
  //     rows.unshift(col);
  //   }
  
  //   // Prepare meta table content
  //   let metaTableContent = [];
    
  //   if (metaTable && metaTable.length >= 2) {
  //     const metaHeaders = metaTable[0];
  //     const metaValues = metaTable[1];
      
  //     const metaColumnCount = metaHeaders.length;
  //     const metaColumnWidths = Array(metaColumnCount).fill(`${100/metaColumnCount}%`);
      
  //     const metaHeaderRow = metaHeaders.map(header => ({
  //       text: header,
  //       style: 'metaHeader'
  //     }));
      
  //     const metaValueRow = metaValues.map(value => ({
  //       text: String(value),
  //       style: 'metaValue'
  //     }));
      
  //     metaTableContent = [
  //       {
  //         margin: [0, 0, 0, 10],
  //         table: {
  //           widths: metaColumnWidths,
  //           headerRows: 1,
  //           body: [metaHeaderRow, metaValueRow]
  //         },
  //         layout: {
  //           hLineWidth: function(i, node) { return 1; },
  //           vLineWidth: function(i, node) { return 1; },
  //           hLineColor: function(i, node) { return '#aaa'; },
  //           vLineColor: function(i, node) { return '#aaa'; },
  //           paddingLeft: function(i) { return 4; },
  //           paddingRight: function(i) { return 4; },
  //           paddingTop: function(i) { return 2; },
  //           paddingBottom: function(i) { return 2; }
  //         }
  //       }
  //     ];
  //   }
    
  //   // Chart content
  //   let chartContent = chart ? [
  //     {
  //       image: chart,
  //       alignment: 'center',
  //       width: 500,
  //       margin: [0, 10, 0, 10]
  //     }
  //   ] : [];
  
  //   // Define table content only if rows exist
  //   let tableContent = [];
  //   if (rows.length > 0) {
  //     tableContent = [
  //       {
  //         layout: 'headerLineOnly',
  //         table: {
  //           widths: widths,
  //           headerRows: 1,
  //           body: rows
  //         }
  //       }
  //     ];
  //   }
  
  //   // Calculate logo height based on width (assuming standard aspect ratio)
  //   // Adjust this calculation if your logo has a different aspect ratio
  //   const logoWidth = 250; // Reduced from 200 to make it smaller
  //   const logoHeight = 250; // Approximate height based on typical logo aspect ratio
  
  //   const docDefinition = {
  //     userPassword: pword,
  //     permissions: {
  //       printing: 'highResolution',
  //       modifying: false,
  //       copying: true,
  //       annotating: true,
  //       fillingForms: true,
  //       contentAccessibility: true,
  //       documentAssembly: true
  //     },
  //     // Increase top margin to make room for the header with the logo
  //     pageMargins: [40, logoHeight, 40, 40], // [left, top, right, bottom]
      
  //     // Add header with logo at top right
  //     header: logo ? function(currentPage, pageCount, pageSize) {
  //       return {
  //         margin: [0, 0, 0, 0], // Add margins to the header [left, top, right, bottom]
  //         columns: [
  //           { width: '*', text: '' }, // Empty column to push logo to right
  //           {
  //             // width: 'auto',
  //             image: logo,
  //             width: logoWidth,
  //             height: logoHeight
  //           }
  //         ]
  //       };
  //     } : null,
      
  //     // Main content without the logo
  //     content: [
  //       ...metaTableContent,  // Meta table first
  //       ...chartContent,      // Chart second
  //       ...tableContent       // Table content last
  //     ],
  //     styles: {
  //       header: {
  //         fontSize: 8,
  //         bold: true,
  //         fillColor: "#0082be",
  //         color: "white"
  //       },
  //       metaHeader: {
  //         fontSize: 8,
  //         bold: true,
  //         fillColor: "#e8e8e8",
  //         color: "#333333"
  //       },
  //       metaValue: {
  //         fontSize: 7,
  //         color: "#000"
  //       }
  //     },
  //     defaultStyle: {
  //       fontSize: 6,
  //     }
  //   };
  
  //   pdfMake.createPdf(docDefinition).download(fileName, (err, res) => {
  //     if (call) {
  //       call();
  //     }
  //   });
  // }

  // static downloadAsPdf33(columns, rows, fileName, columnStyles, pword, type, call, metaTable, chart, logo) {
  //   // Initialize arrays and variables
  //   const col = [];
  //   const widths = new Array(Object.keys(columns).length - 1).fill(0);
  //   let count = 0;
  //   const headerKeys = [];
  //   let totalWidth = 100;
  //   let indexOfComments;
  //   let indexOfPriority;
  
  //   // Only process columns and create headers if rows exist
  //   if (rows.length > 0) {
  //     Object.keys(columns).forEach(k => {
  //       const obj = {
  //         style: 'header',
  //         text: type === "wfhTeams" && columns[k].customTitle ? columns[k].customTitle : columns[k].title
  //       };
  //       headerKeys.push(obj.text);
  //       col.push(obj);
  //     });
  
  //     totalWidth -= 4;
  //     headerKeys.splice(headerKeys.indexOf("SL No."), 1, undefined);
  //     widths.unshift("4%");
  //     count++;
  
  //     if (headerKeys.includes("comments")) {
  //       indexOfComments = headerKeys.indexOf('comments');
  //       headerKeys.splice(indexOfComments, 1, undefined);
  //       totalWidth -= 35;
  //       count++;
  //     }
  
  //     if (headerKeys.includes("priority")) {
  //       indexOfPriority = headerKeys.indexOf('priority');
  //       headerKeys.splice(indexOfPriority, 1, undefined);
  //       totalWidth -= 8;
  //       count++;
  //     }
  
  //     for (let index = 0; index < headerKeys.length; index++) {
  //       const element = headerKeys[index];
  //       if (element) {
  //         widths.splice(headerKeys.indexOf(element), 1, `${totalWidth / (columns.length - count)}%`);
  //       }
  //     }
  
  //     if (indexOfComments !== undefined) {
  //       widths.splice(indexOfComments, 1, "35%");
  //     }
  
  //     if (indexOfPriority !== undefined) {
  //       widths.splice(indexOfPriority, 1, "8%");
  //     }
  
  //     // Add column headers only if we have rows
  //     rows.unshift(col);
  //   }
  
  //   // Prepare meta table content
  //   let metaTableContent = [];
  
  //   if (metaTable && metaTable.length >= 2) {
  //     const metaHeaders = metaTable[0];
  //     const metaValues = metaTable[1];
  
  //     const metaColumnCount = metaHeaders.length;
  //     const metaColumnWidths = Array(metaColumnCount).fill(`${100 / metaColumnCount}%`);
  
  //     const metaHeaderRow = metaHeaders.map(header => ({
  //       text: header,
  //       style: 'metaHeader'
  //     }));
  
  //     const metaValueRow = metaValues.map(value => ({
  //       text: String(value),
  //       style: 'metaValue'
  //     }));
  
  //     metaTableContent = [
  //       {
  //         margin: [0, 0, 0, 10],
  //         table: {
  //           widths: metaColumnWidths,
  //           headerRows: 1,
  //           body: [metaHeaderRow, metaValueRow]
  //         },
  //         layout: {
  //           hLineWidth: function (i, node) { return 1; },
  //           vLineWidth: function (i, node) { return 1; },
  //           hLineColor: function (i, node) { return '#aaa'; },
  //           vLineColor: function (i, node) { return '#aaa'; },
  //           paddingLeft: function (i) { return 4; },
  //           paddingRight: function (i) { return 4; },
  //           paddingTop: function (i) { return 2; },
  //           paddingBottom: function (i) { return 2; }
  //         }
  //       }
  //     ];
  //   }
  
  //   // Chart content
  //   let chartContent = chart ? [
  //     {
  //       image: chart,
  //       alignment: 'center',
  //       width: 500,
  //       margin: [0, 10, 0, 10]
  //     }
  //   ] : [];
  
  //   // Define table content only if rows exist
  //   let tableContent = [];
  //   if (rows.length > 0) {
  //     tableContent = [
  //       {
  //         layout: 'headerLineOnly',
  //         table: {
  //           widths: widths,
  //           headerRows: 1,
  //           body: rows
  //         }
  //       }
  //     ];
  //   }
  
  //   // Define logo dimensions
  //   const logoWidth = 120;
  //   const logoHeight = 50;
  
  //   const docDefinition = {
  //     userPassword: pword,
  //     permissions: {
  //       printing: 'highResolution',
  //       modifying: false,
  //       copying: true,
  //       annotating: true,
  //       fillingForms: true,
  //       contentAccessibility: true,
  //       documentAssembly: true
  //     },
  //     pageMargins: [40, 60, 40, 40], // Adjusted top margin to accommodate header
  
  //     // Add header with logo at top right
  //     header: logo ? function (currentPage, pageCount, pageSize) {
  //       return {
  //         margin: [0, 10, 40, 0], // [left, top, right, bottom]
  //         columns: [
  //           { width: '*', text: '' }, // Empty column to push logo to the right
  //           {
  //             image: logo,
  //             width: logoWidth,
  //             height: logoHeight,
  //             alignment: 'right'
  //           }
  //         ]
  //       };
  //     } : null,
  
  //     // Main content
  //     content: [
  //       ...metaTableContent,  // Meta table first
  //       ...chartContent,      // Chart second
  //       ...tableContent       // Table content last
  //     ],
  //     styles: {
  //       header: {
  //         fontSize: 8,
  //         bold: true,
  //         fillColor: "#0082be",
  //         color: "white"
  //       },
  //       metaHeader: {
  //         fontSize: 8,
  //         bold: true,
  //         fillColor: "#e8e8e8",
  //         color: "#333333"
  //       },
  //       metaValue: {
  //         fontSize: 7,
  //         color: "#000"
  //       }
  //     },
  //     defaultStyle: {
  //       fontSize: 6,
  //     }
  //   };
  
  //   pdfMake.createPdf(docDefinition).download(fileName, (err, res) => {
  //     if (call) {
  //       call();
  //     }
  //   });
  // }

  static downloadAsPdf(columns, rows, fileName, columnStyles, pword, type, call, metaTable, chart, logo, camSummaryTable, title, canvas) {
    const col = [];
    const widths = new Array(Object.keys(columns).length - 1).fill(0);
    let count = 0;
    const headerKeys = [];
    let totalWidth = 100;
    let indexOfComments;
    let indexOfPriority;
  
    if (rows.length > 0) {
      Object.keys(columns).forEach(k => {
        const obj = {
          style: 'header',
          text: type === "wfhTeams" && columns[k].customTitle ? columns[k].customTitle : columns[k].title
        };
        headerKeys.push(obj.text);
        col.push(obj);
      });
  
      totalWidth -= 4;
      headerKeys.splice(headerKeys.indexOf("SL No."), 1, undefined);
      widths.unshift("4%");
      count++;
  
      if (headerKeys.includes("comments")) {
        indexOfComments = headerKeys.indexOf('comments');
        headerKeys.splice(indexOfComments, 1, undefined);
        totalWidth -= 35;
        count++;
      }
  
      if (headerKeys.includes("priority")) {
        indexOfPriority = headerKeys.indexOf('priority');
        headerKeys.splice(indexOfPriority, 1, undefined);
        totalWidth -= 8;
        count++;
      }
  
      for (let index = 0; index < headerKeys.length; index++) {
        const element = headerKeys[index];
        if (element) {
          widths.splice(headerKeys.indexOf(element), 1, `${totalWidth / (columns.length - count)}%`);
        }
      }
  
      if (indexOfComments !== undefined) {
        widths.splice(indexOfComments, 1, "35%");
      }
  
      if (indexOfPriority !== undefined) {
        widths.splice(indexOfPriority, 1, "8%");
      }
  
      rows.unshift(col);
    }
  
    let metaTableContent = [];
  
    if (metaTable && metaTable.length >= 2) {
      const metaHeaders = metaTable[0];
      const metaValues = metaTable[1];
  
      const metaColumnCount = metaHeaders.length;
      const metaColumnWidths = Array(metaColumnCount).fill(`${100 / metaColumnCount}%`);
  
      const metaHeaderRow = metaHeaders.map(header => ({
        text: header,
        style: 'metaHeader'
      }));
  
      const metaValueRow = metaValues.map(value => ({
        text: String(value),
        style: 'metaValue'
      }));
  
      metaTableContent = [
        {
          margin: [0, 0, 0, 10],
          table: {
            widths: metaColumnWidths,
            headerRows: 1,
            body: [metaHeaderRow, metaValueRow]
          },
          layout: {
            hLineWidth: function(i, node) { return 1; },
            vLineWidth: function(i, node) { return 1; },
            hLineColor: function(i, node) { return '#aaa'; },
            vLineColor: function(i, node) { return '#aaa'; },
            paddingLeft: function(i) { return 4; },
            paddingRight: function(i) { return 4; },
            paddingTop: function(i) { return 2; },
            paddingBottom: function(i) { return 2; }
          }
        }
      ];
    }

    let chartSummaryTableContent = [];
    if (camSummaryTable && camSummaryTable.length >= 2 && camSummaryTable[0] && camSummaryTable[0].length > 0) {
      const chartSummaryHeaders = camSummaryTable[0];

      const additionalSummaryHeaders = JSON.parse(JSON.stringify(chartSummaryHeaders))
      additionalSummaryHeaders.fill('');
      additionalSummaryHeaders[0] = 'Camera Summary';

      const chartSummaryValues = camSummaryTable[1];
    
      const chartSummaryColumnCount = chartSummaryHeaders.length;
      const chartSummaryColumnWidths = Array(chartSummaryColumnCount).fill('*');
    
      const chartSummaryHeaderRow = chartSummaryHeaders.map(header => ({
        text: header,
        style: 'metaHeader'
      }));

      const additionalHeaderRow = additionalSummaryHeaders.map(header => ({
        text: header,
        style: 'metaHeader'
      }));
    
    
      const chartSummaryValueRows = chartSummaryValues.map(row => {
        const normalizedRow = chartSummaryHeaders.map((_, index) => ({
          text: row[index] !== undefined ? String(row[index]) : '',
          style: 'metaValue'
        }));
        return normalizedRow;
      });
  

      chartSummaryTableContent = [
        {
          margin: [0, 0, 0, 10],
          table: {
            widths: chartSummaryColumnWidths,
            headerRows: 1,
            body: [additionalHeaderRow, chartSummaryHeaderRow, ...chartSummaryValueRows]
          },
          layout: {
            hLineWidth: function(i, node) { return 1; },
            vLineWidth: function(i, node) { return 1; },
            hLineColor: function(i, node) { return '#aaa'; },
            vLineColor: function(i, node) { return '#aaa'; },
            paddingLeft: function(i) { return 4; },
            paddingRight: function(i) { return 4; },
            paddingTop: function(i) { return 2; },
            paddingBottom: function(i) { return 2; }
          }
        }
      ];
    }
    
  
    let chartContent = chart ? [
      {
        image: chart,
        alignment: 'center',
        width: 700,
        margin: [0, 10, 0, 10]
      }
    ] : [];
  
    let tableContent = [];
    if (rows.length > 0) {
      tableContent = [
        {
          layout: 'headerLineOnly',
          table: {
            widths: widths,
            headerRows: 1,
            body: rows
          }
        }
      ];
    }
  
    const logoWidth = 150; 
    const logoHeight = 130; 
  
    const pageWidth = 750;
  const pageHeight = 841.89;

  const docDefinition = {
    pageSize: { width: pageWidth, height: pageHeight+(canvas && canvas.height?(canvas.height/5):0) },
      userPassword: pword,
      permissions: {
        printing: 'highResolution',
        modifying: false,
        copying: true,
        annotating: true,
        fillingForms: true,
        contentAccessibility: true,
        documentAssembly: true
      },
      pageMargins: [40, 150, 40, 40], 
      header: logo ? function(currentPage, pageCount, pageSize) {
        return {
          margin: [0, 10, 40, 0], 
          columns: [
            // { width: '*', text: '' }, 
            {
              width: '*',
              text: title ? title : '',
              style: 'reportTitle',
              alignment: 'center',
              margin: [logoWidth/2, logoHeight/2, 0, 0]
              // margin: [10, 20, 0, 10]

            },
            {
              image: logo,
              width: logoWidth,
              height: logoHeight,
              alignment: 'right'
            }
          ]
        };
      } : function(currentPage, pageCount, pageSize) {
        return {
          margin: [0, 10, 40, 0], 
          columns: [
            // { width: '*', text: '' }, 
            {
              width: '*',
              text: title ? title : '',
              style: 'reportTitle',
              alignment: 'center',
            }
          ]
        };
      } ,
      content: [
        ...metaTableContent,  
        ...chartContent,      
        ...tableContent,
        ...chartSummaryTableContent       
      ],
      styles: {
        header: {
          fontSize: 8,
          bold: true,
          fillColor: "#0082be",
          color: "white"
        },
        reportTitle: {
          fontSize: 16,
          bold: true,
          color: "#000000"
        },
        metaHeader: {
          fontSize: 8,
          bold: true,
          fillColor: "#e8e8e8",
          color: "#333333"
        },
        metaValue: {
          fontSize: 7,
          color: "#000"
        }
      },
      defaultStyle: {
        fontSize: 6,
      }
    };
  
    pdfMake.createPdf(docDefinition).download(fileName, (err, res) => {
      if (call) {
        call();
      }
    });
  }
  
  
  static prepExcelDownload(itemList, selectedItems, fileName, timeAttr, eventsByGroupId, orgPlaces, pword, type, call, startingIndex, timezone, meta, isCsv) {
    if (selectedItems.includes("selectAll")) {
      selectedItems.splice(selectedItems.indexOf("selectAll"), 1)
    }

     const metaHeaders = [];
    const metaValues = [];
    
    if (meta && typeof meta === 'object') {
      Object.keys(meta).forEach(key => {
        metaHeaders.push(key);
        metaValues.push(meta[key]);
      });
    }
    const metaTable = [metaHeaders, metaValues];

    const camEvents = [];
    let index = startingIndex ? startingIndex : 1;
    for (const item of itemList) {
      const e = {};
      e['SL No.'] = index;
      for (const sItem of selectedItems) {
        if (sItem === timeAttr) {
          e[customNameForWFH[sItem] || sItem] = (moment(item[sItem]).tz(timezone ? timezone : "").format('YYYY-DD-MM HH:mm:ss:SSS') )+ "  " + (timezone ? timezone : "")
         
        } else if (sItem === 'tags') {
          /*if(item.tags) {
            const tagKs = Object.keys(item.tags)
            e[sItem] = null
            for(const tagK of tagKs) {
              if(!e[sItem]) {
                e[sItem] = tagK + ' : ' + item.tags[tagK]
              } else {
                e[sItem] = e[sItem] + ', '  + tagK + ' : ' + item.tags[tagK]
              }
            }
          } else {
            e[sItem] = ''
          }*/
          if (item.tags) {
            const tagKs = Object.keys(item.tags)
            for (const tagK of tagKs) {
              //if(item.tags[tagK] && item.tags[tagK].length > 0) {
              if (item.tags[tagK] !== null && item.tags[tagK] !== undefined) {
                e[tagK] = item.tags[tagK]
              }
            }
          }
        } else if (sItem === 'grouped_events') {
          e[customNameForWFH[sItem] || sItem] = (item.groupId && eventsByGroupId[item.groupId]) ? (eventsByGroupId[item.groupId].length + 1) : 1
        } else if (sItem === 'placeId') {
          e[type && type == "wfhTeams" && customNameForWFH[sItem] ? customNameForWFH[sItem] : sItem] = AppHelper.renderPlaceid(item, orgPlaces)
        } else if (sItem === 'place_name') {
          e[type && type == "wfhTeams" && customNameForWFH[sItem] ? customNameForWFH[sItem] : 'Place Name'] = AppHelper.renderPlaceName(item, orgPlaces)
        } else if (sItem === 'comments') {
          e[customNameForWFH[sItem] || sItem] = AppHelper.renderComment(item, orgPlaces)
        } else if (sItem === 'cam_name') {
          e[type && type == "wfhTeams" && customNameForWFH[sItem] ? customNameForWFH[sItem] : 'Cam Name'] = AppHelper.renderCamName(item, orgPlaces)
        } else if (sItem === 'priority') {
          e[customNameForWFH[sItem] || sItem] = AppHelper.getPriorityStr(item.priority)
        } else {
          e[type && type == "wfhTeams" && customNameForWFH[sItem] ? customNameForWFH[sItem] : sItem] = item[sItem];
        }
      }
      camEvents.push(e);
      index++;
    }
    // this.exportAsExcelFile(camEvents, fileName, pword, call);

  // const metaContent = meta ? Object.keys(meta).map(k => ({ [k]: meta[k] })) : [];
  const metaContent = Object.keys(meta).map(key => [key, meta[key]]);

  // const combinedData = [...metaContent, ...camEvents];
    if (isCsv) {
      this.exportAsCsvFile(metaTable, camEvents, fileName, pword, call);
    } else {
      this.exportAsExcelFile(metaTable, camEvents, fileName, pword, call);
    }
  }

  static prepExcelDownloadForAudit(itemList, selectedItems, fileName, timeAttr, subSet, timezone) {
    const auditEvents = [];
    let index = 1;
    for (const item of itemList) {
      const e = {};

      e['No.'] = index;
      for (const sItem of selectedItems) {
        if (sItem === timeAttr) {
          e[sItem] = (moment(item[sItem]).tz(timezone ? timezone : "").format('YYYY-DD-MM HH:mm:ss:SSS') )+ " \n " + (timezone ? timezone : "")
        } else if (sItem === 'data') {
          if (item.data) {
            const tagKs = Object.keys(item.data)
            for (const tagK of tagKs) {
              if (subSet.includes(tagK)) {
                if (item.data[tagK] !== null && item.data[tagK] !== undefined) {
                  e[tagK] = item.data[tagK]
                }
              }
            }
          }
        } else {
          e[sItem] = item[sItem];
        }
      }
      auditEvents.push(e);
      index++;
    }
    this.exportAsExcelFile(auditEvents, fileName);
  }

  static prepPdfDownload(itemList, selectedItems, fileName, columnStyles, eventsByGroupId, orgPlaces, pword, type, call, startingIndex, timeAttr, timezone, meta, chart, logo, camSummary, title, canvas) {
    if (selectedItems.includes("selectAll")) {
      selectedItems.splice(selectedItems.indexOf("selectAll"), 1)
    }
    const metaHeaders = [];
    const metaValues = [];

    if (meta && typeof meta === 'object') {
      Object.keys(meta).forEach(key => {
        metaHeaders.push(key);
        metaValues.push(meta[key]);
      });
    }

    const camSummaryHeaders = [];

    const camSummaryValues = [];
    
    if (camSummary && Array.isArray(camSummary) && camSummary.length > 0) {
      // Assuming all objects have the same keys
      Object.keys(camSummary[0]).forEach(key => {
        camSummaryHeaders.push(key);
      });
    
      camSummary.forEach(item => {
        camSummaryValues.push(Object.values(item));
      });
    }

    const metaTable = [metaHeaders, metaValues];
    const camSummaryTable = [camSummaryHeaders, camSummaryValues];

    const columns = [];
    columns.push({ title: 'SL No.' });
    for (const sItem of selectedItems) {
      if (type == "wfhTeams") {
        columns.push({ title: sItem, customTitle: customNameForWFH[sItem] });
      } else {
        columns.push({ title: sItem });
      }
    }
    const rows = [];
    let tempRow = [];
    let index = startingIndex ? startingIndex : 1;
    for (const item of itemList) {
      tempRow = [index];
      for (const sItem of selectedItems) {
        if (sItem === timeAttr) {
                tempRow.push(moment(item[sItem]).tz(timezone ? timezone : "").format('YYYY-DD-MM HH:mm:ss:SSS') + "\n" + (timezone ? timezone : ""))
        } else
        if (sItem === 'tags') {
          let tagStr = null
          if (item.tags) {
            const tagKs = Object.keys(item.tags)
            for (const tagK of tagKs) {
              if (!tagStr) {
                tagStr = tagK + ' : ' + item.tags[tagK]
              } else {
                tagStr = tagStr + ', ' + tagK + ' : ' + item.tags[tagK]
              }
            }
          } else {
            tagStr = ''
          }
          tempRow.push(tagStr);
        } else if (sItem === 'grouped_events') {
          const grpCount = (item.groupId && eventsByGroupId[item.groupId]) ? (eventsByGroupId[item.groupId].length + 1) : 1
          tempRow.push(grpCount)
        } else if (sItem === 'placeId') {
          tempRow.push(AppHelper.renderPlaceid(item, orgPlaces))
        } else if (sItem === 'place_name') {
          tempRow.push(AppHelper.renderPlaceName(item, orgPlaces))
        } else if (sItem === 'comments') {
          tempRow.push(AppHelper.renderComment(item, orgPlaces))
        } else if (sItem === 'cam_name') {
          tempRow.push(AppHelper.renderCamName(item, orgPlaces))
        } else if (sItem === 'priority') {
          tempRow.push(AppHelper.getPriorityStr(item.priority))
        } else {
          tempRow.push(item[sItem]);
        }
      }
      rows.push(tempRow);
      index++;
    }
    this.downloadAsPdf(columns, rows, fileName, columnStyles, pword, type, call, metaTable, chart, logo, camSummaryTable, title, canvas);
  }
}